import { Controller } from "@hotwired/stimulus"
import { DateRangePicker } from "flowbite-datepicker"

export default class extends Controller {
  static values = {
    minDate: String,
    maxDate: String
  }

  static targets = ["startsOnInput", "endsOnInput"]

  connect() {
    let options = {
      format: "yyyy-mm-dd",
      allowOneSidedRange: true,
      clearBtn: true,
      todayHighlight: true
    }

    if (this.minDateValue) {
      options.minDate = this.minDateValue
    }
    if (this.maxDateValue) {
      options.maxDate = this.maxDateValue
    }

    this.datepicker = new DateRangePicker(this.element, options)

    this.datepicker.datepickers.forEach((picker) => {
      picker.pickerElement.classList.add("tw")

      picker.element.addEventListener("show", () => {
        picker.element.lastValue = picker.element.value
      })

      picker.element.addEventListener("hide", () => {
        if (picker.element.lastValue !== picker.element.value) {
          this.dispatch("changed", { target: this.element })
        }
      })
    })
  }

  disconnect() {
    this.datepicker.destroy()
  }

  onClickRangeSelected(e) {
    if (!this.hasStartsOnInputTarget || !this.hasEndsOnInputTarget) {
      return
    }

    let dataset = e.currentTarget.dataset

    this.startsOnInputTarget.value = dataset.startsOn || ""
    this.endsOnInputTarget.value = dataset.endsOn || ""

    this.dispatch("changed", { target: this.element })
  }
}
